import http from '@/requests/http'

class Transfer {
  static findAll (params) {
    return http.post('transfers', params)
  }
  static view (params) {
    return http.post('transfers/view', params)
  }
  static update (params) {
    return http.post('transfers/update', params)
  }
  static transfer (params) {
    return http.post('transfers/transfer', params)
  }
  static unTransfer (params) {
    return http.post('transfers/untransfer', params)
  }
}

export default Transfer
